<!-- 注册登录页面 login  -->
<template style="user-select: none">
  <div>
    <div class="login">
      <div class="topImgDiv">
        <img src="../assets/image/btn_beijingkapian_nor.png" alt="顶部" class="topImg" />
        <div class="logoImgDiv">
          <img src="../assets/image/btn_logob_nor.png" alt="logo" class="logoImg" />
          <!-- <img
            src="../assets/image/btn_jiao.png"
            alt="logo"
            class="logoImg"
          /> -->
        </div>
        <!--   <div class="logoImgDiv">
          <img          <img src="../assets/image/btn_jiao.png" alt="logo" class="logoImg" />

            src="../assets/image/btn_jiao'zhuan_nor1.png"
            alt="logo"
            class="logoImg"jiaozhuan
          />
        </div> -->
      </div>
      <div class="schoolName">沈阳工程学院</div>
      <!-- <div class="schoolName">沈阳工程学院</div> -->
      <!--       <div class="schoolName">东北大学</div>
 -->
      <div class="name">校友资源服务平台</div>
      <div class="loginCard">
        <el-form :rules="rules" :model="postForm" ref="form" class="demo-ruleForm">
          <div class="phone">
            <el-form-item prop="phone">
              <el-input placeholder="请输入手机号码" v-model="postForm.phone">
                <i slot="prefix" class="el-icon-mobile-phone"></i>
              </el-input>
            </el-form-item>
          </div>
          <div class="code">
            <el-form-item prop="phoneCode">
              <el-input placeholder="请输入验证码" v-model="postForm.phoneCode">
                <i slot="prefix" class="el-icon-unlock"></i>
                <button slot="append" v-show="show" class="codeBtn" @click.prevent="getPhoneCode">
                  获取验证码
                </button>
                <button slot="append" v-show="!show" class="disableCodeBtn">
                  {{ count }} 秒后重试
                </button>
              </el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="drag">
            <drag-verify
              ref="dragVerify"
              :width=300
              :isPassing.sync="isPassing"
              text="请按住滑块拖动"
              successText="验证通过"
              handlerIcon="el-icon-d-arrow-right"
              successIcon="el-icon-circle-check"
              handlerBg="#95c0dd"
              >
            </drag-verify>
          </div>
        <div class="loginBtnDiv">
          <button class="loginBtn" @click="login" :disabled="isSubmitting">
            注册/登录
          </button>
        </div>
      </div>
      <!--      <div class="other">
        <el-divider>
          <div>您也可以使用以下方式登录</div>
        </el-divider>
        <div class="emailDiv">
          <img src="../assets/image/btn_youxianga_nor.png" alt="邮箱" class="email" @click="gotoEmailLogin" />
        </div>
      </div> -->
      <!-- <div class="copyright">技术 • 运营</div>
      <div class="copyrightCompany">辽宁校友汇数据科技有限公司</div> -->
    </div>
    
  </div>
  
</template>
<script>
import dragVerify from "@/components/dragVerify.vue";
export default {
  components: {
    dragVerify,
  },
  data() {
    return {
      postForm: {
        phone: "",
        phoneCode: "",
      },
      isSubmitting: false,
      openid: "",
      code: "",
      userData: "",
      user_id: "",
      show: true,
      count: "",
      timer: null,
      imgUrl: "",
      state: "",
      isPassing: false,
      // localUrl: "http://localhost:8080/login",
      localUrl: "https://gcxy.alumni-resource.com/login",
      // localUrl: "http://localhost:8089/xyh",

      rules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        phoneCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
    };
  },
  created() {

    const openid = window.localStorage.getItem("openid") || ''
    if (!openid) {
      console.info("没有openid，开始获取openid")
      this.getCode();
    } else {
      if (window.localStorage.getItem("phone")) {
        this.getUserData();
        return;
      }
    }
  },
  methods: {
    getUrlCode() {
      // 截取url中的code方法
      const url = location.search;
      const theRequest = {};
      if (url.indexOf("?") !== -1) {
        const str = url.substr(1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    getCode() {
      //   var appid = "wx56458d4baeea3d63"; // 海事大学
      //   // 获取URL中的查询参数
      //   const urlParams = new URLSearchParams(window.location.search);
      //   // 获取is_snapshotuser参数的值
      //   const is_snapshotuser = urlParams.get("is_snapshotuser");

      //   this.getOpenIdApi();
      //   if (is_snapshotuser == "1" && is_snapshotuser) {
      //     // 如果is_snapshotuser的值为1，执行额外的微信授权
      //     this.performWeChatAuthorization(appid);
      //   } else {
      //     // 如果没有code，则去请求
      //     this.code = this.getUrlCode().code; // 截取code
      //     setTimeout(() => {
      //       if (this.code == null || this.code === "") {
      //         //https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx807d86fb6b3d4fd2&redirect_uri=http%3A%2F%2Fdevelopers.weixin.qq.com&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect
      //         window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
      //           this.localUrl
      //         )}&response_type=code&scope=snsapi_userinfo&forcePopup=true&forceSnapShot=true&state=STATE&connect_redirect=1#wechat_redirect`;
      //       } else {
      //         this.getOpenIdApi();
      //       }
      //     }, 500);
      //  }

      // 非静默授权，第一次有弹框
      var local = window.location.href; // 获取页面url
      // var local = 'http://liuwd.natapp1.cc/login'
      //var local = "https://wx.dlmu.edu.cn/app/schoolfellow/xyhall/login"; // 获取页面url
      // TODO--START
      var appid = "wx56458d4baeea3d63"; // 校友汇公众号
      //  var appid = "wxae254986265f7048";
      // TODO--END
      //var appid = "wx29f060ce3bcff62e"; // 海事大学
      this.code = this.getUrlCode().code; // 截取code
      console.info("code", this.code);
      // this.getOpenIdApi();
      setTimeout(() => {
        if (this.code == null || this.code === "") {
          console.info("没有code，开始获取code")
          // 如果没有code，则去请求
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`;
        } else {
          this.getOpenIdApi();
        }
      },500)
    },
    async performWeChatAuthorization(appid) {
      // 当is_snapshotuser为1时执行微信授权
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
        this.localUrl
      )}&response_type=code&scope=snsapi_userinfo&forcePopup=true&forceSnapShot=true&state=STATE&connect_redirect=1&is_snapshotuser=1#wechat_redirect`;
    },
    async getOpenIdApi() {
      const result = await this.$http.get("/login/wxcallback", {
        params: { code: this.code },
      });
      const { openid, img } = result.data;
      // 拿到openid 走短信登录
      if (openid != null && openid !== "") {
        this.openid = openid;
        window.localStorage.setItem("openid", this.openid);
        this.imgUrl = img;
        // window.localStorage.setItem("imgUrl", this.imgUrl);
        // 用户二次登陆系统
        this.getUserData();
      } else {
        // 未拿到openid重新进入
        window.location.href = this.localUrl;
      }
    },
    async getUserData() {
      const result = await this.$http({
        url: "/login/isSignUp",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({
          openid: window.localStorage.getItem("openid"),
        }),
      });
      if (result.status !== 200) {
        this.$toast("请求失败");
        return;
      }
      const { code, id } = result.data;
      
      this.user_id = id;
      window.localStorage.setItem("user_id", this.user_id);

      // 保存登录态token，后续请求由 axios 拦截器统一带上
      if (result.data.token) {
        window.localStorage.setItem("token", result.data.token);
      }

      if (code === "999") {
        this.$toast("登录失败，请联系管理员");
        window.localStorage.removeItem("phone");
        return;
      }

      if (code === "201") {
        window.localStorage.removeItem("openid");
        this.$toast("系统错误");
        return;
      }
      // 104已注册退出登录 需重新短信登录
      if (code === "104") {
        this.state = 1;
        // window.localStorage.removeItem('openid')
        return;
      }
      // 102没有填写学籍卡
      if (code === "102") {
        await this.$router.push("/userData");
        return;
      }
      // 302填写完学籍卡但未提交人工审核
      if (code === "302") {
        await this.$router.push("/failAuthentication");
        return;
      }
      // 402人工审核等待状态
      if (code === "402") {
        await this.$router.push("/contactStaff");
        return;
      }
      // 411 自动匹配/人工审核通过 但未填写身份证
      if (code === "411") {
        await this.$router.push("/idSucess");
        return;
      }
      // 401 自动匹配/人工审核通过 已填写身份证但未实名
      if (code === "400") {
        await this.$router.push("/idSucess?isWriteIdCard=1");
        return;
      }
      
      if (code === "105") {

        // 未补全个人信息
        if (!window.localStorage.getItem("isCompletionData")) {
          await this.$router.push("/completePersonInfo");
          return;
        }

        // 已补全个人信息
        if (window.localStorage.getItem("isCompletionData") === 1) {
          await this.$router.push("/completeInfo");
          return;
        }
      }
      
      if (code === "999") {
        this.state = 0;
        return;
      }
      // 103已注册 未退出登录
      if (code === "103") {
        await this.$router.push("/index");
      }
      // 照片重置，重新上传
      if (code === "109") {
        await this.$router.push("/uploadTip");
      }
      // 照片重置，重新上传，审批没有通过
      if (code === "110") {
        await this.$router.push("/uploadFail");
      }
      // 照片重置，重新上传，审批中
      if (code === "111") {
        await this.$router.push("/uploadSucc");
      }
    },
    async getPhoneCode() {
      if (this.postForm.phone === "") {
        this.$toast("请输入手机号");
      } else {
        if (!this.isPassing) {
          this.$toast("请先滑动验证");
          return;
        }
        this.settime();
        const result = await this.$http({
          url: "/login/makeSmsCode",
          method: "POST",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: this.$qs.stringify({ phone: this.postForm.phone }),
        });
        if (result.data.code === "101") {
          this.$toast("发送成功");
          // console.log(result);
        } else {
          this.$toast(result.data.msg);
        }
      }
    },
    settime() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async login() {
      //   if (this.isSubmitting) {
      //   return; // 如果正在提交，直接返回，防止重复提交
      // }
      // this.isSubmitting = true; // 设置状态为正在提交
      // this.$router.push({
      //   path: "/Index",
      //   query: {
      //     openid: this.openid
      //   }
      // });
      // this.$router.push('/Index');
      // this.$router.push("/Index");

      window.localStorage.setItem("phone", this.postForm.phone);
      this.$refs.form.validate(async (valid) => {
        // 请求api之前的一个前端验证
        if (!valid) {
          return;
        }
        const result = await this.$http({
          url: "/login/phoneSignUp",
          method: "POST",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: this.$qs.stringify({
            phone: this.postForm.phone,
            code: this.postForm.phoneCode,
            openid: window.localStorage.getItem("openid"),
            img: window.localStorage.getItem("imgUrl"),
            // openid:this.openid,
            // img:this.imgUrl,
            // phoneSignUp需要给我传状态 判断 是否注册  如果code是 999  state给我传0   如果code是104  state给我传1
            state: this.state,
          }),
        });
        if (result.data.code !== "101") {
          this.$toast(result.data.msg);
          return;
        }
        // 保存登录态token，后续请求由 axios 拦截器统一带上
        if (result.data.token) {
          window.localStorage.setItem("token", result.data.token);
        }
        await this.getUserData();
      });
    },
    gotoEmailLogin() {
      return this.$router.push("/emailLogin");
    },
  },
};
</script>
<style lang="less" scoped>
.login::-webkit-scrollbar {
  display: none;
}

.login {
  position: relative;
  min-height: 100vh;

  .topImgDiv {
    position: relative;
    width: 100%;
    margin-bottom: 15%;

    .topImg {
      width: 100%;
    }

    .logoImgDiv {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%);
      width: 33%;

      .logoImg {
        width: 100%;
      }
    }
  }

  .schoolName,
  .name {
    margin-bottom: 10px;
    font-size: 1.3rem;
    font-weight: bold;
    color: #000000;
    text-align: center;
  }

  .loginCard {
    position: relative;
    left: 5%;
    width: 90%;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 2px 3px 5px 1px rgba(140, 158, 206, 0.84);
    border-radius: 15px;

    .drag {
      margin-top: 20px;
      position: relative;
      left: 5%;
      width: 90%;
    }

    .phone,
    .code {
      position: relative;
      left: 5%;
      width: 90%;

      /deep/.el-input__inner {
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0;
        color: #666666;
        margin-top: 20px;
      }

      .codeBtn {
        background-color: white;
        border: 1px solid #00706e;
        padding: 4px 8px;
        border-radius: 20px;
      }

      .disableCodeBtn {
        background-color: white;
        border: 1px solid gray;
        color: gray;
        padding: 4px 8px;
        border-radius: 20px;
      }
    }

    .loginBtnDiv {
      position: relative;
      left: 5%;
      width: 90%;
      margin-top: 20px;

      .loginBtn {
        margin-bottom: 30px;
        width: 100%;
        font-size: 1.1rem;
        background: linear-gradient(270deg, #00706e, #00706e);
        border-radius: 45px;
        border: none;
        padding: 10px 0;
        color: white;
      }
    }
  }

  .other {
    position: relative;
    margin-top: 20px;
    left: 2%;
    width: 96%;

    /deep/.el-divider__text {
      background-color: #f5f5f5;
      white-space: nowrap;
      font-weight: bold;
      color: #333333;
    }

    .email {
      position: relative;
      width: 35px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

/deep/.el-input-group__append {
  padding: 0;
  background-color: white;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  color: #00706e;
}

/deep/.el-input__prefix {
  top: 45%;
}

/deep/.el-form-item__content {
  line-height: 0;
}

/deep/ .el-form-item {
  margin-bottom: 0;
}

/deep/.el-icon-mobile-phone,
.el-icon-unlock {
  font-size: 20px;
}

.copyright {
  position: absolute;
  bottom: 14%;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 400;
  color: #999999;
}

.copyrightCompany {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 400;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue